import React from 'react';
import { connect } from 'react-redux';
import { CMSContent, BoxedContent } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import UserLockout from '../utils/user_lockout';
import Layout from '../Components/Layout';
import EnterTickets from '../Components/Enter_old/EnterTickets';
// import EnterTicketsPage from '../Components/Enter/EnterTicketsPage';

const EnterPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    React.useEffect(() => {
        // Only scroll to top if there's no hash in the URL
        if (!window.location.hash) {
            window.scrollTo(0, 0);
        }
    }, []);
    //? Note: Firebase CMS webContent and webMenu will be requested and stored on first pageload / refresh
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            {/*
            //TODO: Temporary disabled until we got the approval to add draw games
            <EnterTicketsPage />
            */}

            <div>
                <UserLockout>
                    <div className='enter-container'>
                        <div className='row justify-content-center'>
                            <div className='entry-box col-md-6'>
                                <EnterTickets />
                            </div>
                            <div className='entry-box col-md-6'>
                                <CMSContent
                                    localStorageObject='webContent'
                                    contentPath='data.ticketEntry.ticketEntryContent.contentHTML'
                                    cmsSourceFirebase={cmsSourceFirebase}
                                />
                            </div>
                        </div>
                        <div className='row justify-content-center'>
                            <div className='col-12'>
                                <BoxedContent note='Where are my numbers section' hash='enter-help' isActive={true} title='WHERE ARE MY NUMBERS?'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <CMSContent
                                                localStorageObject='webContent'
                                                contentPath='data.ticketEntry.ticketEntryTickets.ticketEntryFront.contentHTML'
                                                cmsSourceFirebase={cmsSourceFirebase}
                                            />
                                            <CMSContent
                                                localStorageObject='webContent'
                                                contentPath='data.ticketEntry.ticketEntryTickets.ticketEntryFront.image'
                                                className='img-fluid mx-auto d-block'
                                                cmsSourceFirebase={cmsSourceFirebase}
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <CMSContent
                                                localStorageObject='webContent'
                                                contentPath='data.ticketEntry.ticketEntryTickets.ticketEntryBack.contentHTML'
                                                cmsSourceFirebase={cmsSourceFirebase}
                                            />
                                            <CMSContent
                                                localStorageObject='webContent'
                                                contentPath='data.ticketEntry.ticketEntryTickets.ticketEntryBack.image'
                                                className='img-fluid mx-auto d-block'
                                                cmsSourceFirebase={cmsSourceFirebase}
                                            />
                                        </div>
                                    </div>
                                </BoxedContent>
                            </div>
                        </div>
                        <div className='row justify-content-center'>
                            <div className='col-12'>
                                <BoxedContent note='FAQ section' hash='faq' isActive={false} title='FAQ'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <CMSContent
                                                localStorageObject='webContent'
                                                contentPath='data.ticketEntry.ticketEntryFAQ.contentHTML'
                                                cmsSourceFirebase={cmsSourceFirebase}
                                            />
                                        </div>
                                    </div>
                                </BoxedContent>
                            </div>
                        </div>
                    </div>
                </UserLockout>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterPage);
